import React from 'react';

import { IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import ProfileButton from './ProfileButton';
import ProfileMenuItems from './ProfileMenuItems';
import StyledMenu from './StyledComponents/StyledMenu';

const ProfileMenu = ({
    match,
    profileValues,
    redirect,
    selectedTheme,
    setTheme,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                id="navbar-profile-button"
                onClick={handleClick}
                sx={{ p: 0 }}
            >
                <ProfileButton
                    avatarOnly={true}
                    profileValues={profileValues}
                />
            </IconButton>
            <StyledMenu
                anchorEl={anchorEl}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                id="account-menu"
                onClick={handleClose}
                onClose={handleClose}
                open={open}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            overflow: 'visible',
                            '& > .MuiList-root ': {
                                display: 'flex',
                                flexDirection: 'column',
                                paddingTop: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <ProfileMenuItems
                    {...{
                        handleClose,
                        match,
                        profileValues,
                        redirect,
                        selectedTheme,
                        setTheme,
                    }}
                />
            </StyledMenu>
        </>
    );
};

ProfileMenu.propTypes = {
    match: PropTypes.object,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setTheme: PropTypes.func,
};

export default ProfileMenu;
